/**
 * Created by Ning Jiang on 2021-06-22.
 */

import {gsap, TimelineLite} from "gsap";
import {DeadwoodRipGameAssets} from "../../../DeadwoodRipGameAssets";
import {DeadwoodRipLayers, Layers} from "../../../view/DeadwoodRipLayers";
import {BitmapCountUp} from "../../../../core/component/BitmapCountUp";
import {ICountUp} from "../../ICountUp";

export class BigWinCountUp extends PIXI.Container implements ICountUp {

    protected _countUp:BitmapCountUp;
    private _endingScale:number = 0.6;

    public set externalAlpha(value:number) {
        this._countUp.alpha = value;
    }

    public get externalAlpha():number {
        return this._countUp.alpha;
    }

    constructor() {
        super();

        const style = {
            fontName : DeadwoodRipGameAssets.BITMAP_FONT_WIN_COUNT_UP,
            fontSize : 70,
            tint : parseInt(("#ffffff").replace(/^#/, ''), 16)
        };
        this._countUp = new BitmapCountUp(style);
        this._countUp.letterSpacing = -30;
        (<PIXI.Point>this._countUp.anchor).y = 0.82;
        this._countUp.shrinkSize = true;
        this._countUp.visible = false;
        this.addChild(this._countUp);
        this.position.set(360, 360);
        DeadwoodRipLayers.getLayer(Layers.WIN_COUNT_UP)?.addChild(this);
    }

    public getCountUpAnimation(from:number, to:number, duration:number):TimelineLite {
        const tl = new TimelineLite();
        tl.add([
            () => {
                this._countUp.maxTextWidth = 580;
                this._countUp.scale.set(1);
                this._countUp.alpha = 1;
                this._countUp.visible = true;
            },
            this._countUp.getCountUpAnimation(from, to, duration, `power2.out`)
        ]);

        return tl;
    }

    public stay():TimelineLite {
        const tl = new TimelineLite();
        tl.add([
            gsap.to(this._countUp.scale, {
                duration : 0.5,
                x : this._endingScale,
                y : this._endingScale,
                ease : `elastic.out(1, 1)`
            }),
        ]);
        return tl;
    }

    public remove():TimelineLite {
        const tl = new TimelineLite();
        if(this._countUp.visible) {
            tl.add(gsap.to(this._countUp, {duration : 0.5, alpha : 0, y : -100, ease : `power2.in`}), `+=0.2`); // stay a short while after count up.
            tl.add(() => {
                this._countUp.y = 0;
                this._countUp.visible = false;
            });
        }

        return tl;
    }

    public showAfterRemoved():void {
        this._countUp.visible = true;
    }

    public onEnd(callback:() => void):void {
        this._countUp.onEnd = callback;
    }
}